
const user = JSON.parse(localStorage.getItem('profile'))

export const initialState = {
    selling: [
        {
          itemName: "",
          unitPrice: "",
          quantity: 0,
          discount: "",
          amount: "",
          itemType: "",
        }
      ],
      payable: [
        {
          itemName: "",
          unitPrice: "",
          quantity: 0,
          discount: "",
          amount: "",
          itemType: "",
        }
      ],
    total: 0,
    paymentMode:'',
    bookingType: 'FIT',
    pax:0,
    // notes: user?.userProfile?.paymentDetails,
    // rates: '',
    // vat: 0,
    // currency: '',
    invoiceNumber:  100000,
    // status: '',
    creator: '',
}
